import React, { useMemo, useEffect } from 'react'
import { useStore } from 'effector-react'
import { Page } from '../../../UI'
import { TransferPolicyMode } from '../../../../shared/enum'
import {
  $transferPolicy,
  $transferPolicyLoading,
} from '../../../../states/TransferPolicy/store'
import {
  getTransferPolicyFx,
  updateTransferPolicyFx,
} from '../../../../states/TransferPolicy/event'

const MODE_OPTIONS = [
  {
    key: TransferPolicyMode.DISABLED,
    value: 'Полный запрет переводов',
  },
  {
    key: TransferPolicyMode.ALLOWED_FOR_ALL,
    value: 'Разрешено всем без условий',
  },
  {
    key: TransferPolicyMode.ALLOWED_FOR_USERS,
    value: 'Разрешено пользователям с флагом',
  },
  {
    key: TransferPolicyMode.ALLOWED_FOR_USERS_AND_COUNTRIES,
    value: 'Флаг пользователя + страна',
  },
  {
    key: TransferPolicyMode.ALLOWED_FOR_SELECTED_COUNTRIES,
    value: 'Только по стране (флаг игнорируется)',
  },
]

const SHOW_COUNTRIES_MODES = [
  TransferPolicyMode.ALLOWED_FOR_USERS_AND_COUNTRIES,
  TransferPolicyMode.ALLOWED_FOR_SELECTED_COUNTRIES,
]

const TransferPolicyEdit: React.FC = () => {
  const transferPolicy = useStore($transferPolicy)
  const transferPolicyLoading = useStore($transferPolicyLoading)

  // Загружаем данные при монтировании
  useEffect(() => {
    getTransferPolicyFx()
  }, [])

  const formValue = useMemo(() => {
    if (!transferPolicy) {
      return null
    }

    return {
      ...transferPolicy,
      allowedCountries: Array.isArray(transferPolicy.allowedCountries)
        ? transferPolicy.allowedCountries.join(', ')
        : transferPolicy.allowedCountries || '',
    }
  }, [transferPolicy])

  const parseCountries = (raw: string): string[] | null => {
    if (!raw || raw.trim() === '') {
      return []
    }

    const codes = raw
      .split(',')
      .map((s) => s.trim().toUpperCase())
      .filter(Boolean)

    const invalid = codes.find((c) => !/^[A-Z]{2}$/.test(c))
    if (invalid) {
      return null
    }

    return codes
  }

  const handleSubmit = (data: any) => {
    const currentCountries = transferPolicy?.allowedCountries || []

    let countries: string[] = currentCountries

    // Парсим страны только если поле сейчас видно
    const shouldShowCountries = SHOW_COUNTRIES_MODES.includes(data.mode)

    if (shouldShowCountries && typeof data.allowedCountries === 'string') {
      const result = parseCountries(data.allowedCountries)
      if (result === null) {
        // Здесь можно добавить уведомление об ошибке
        alert('Некорректные коды стран. Используйте формат: LV, EE, LT')
        return
      }
      countries = result
    }

    updateTransferPolicyFx({
      mode: data.mode,
      countries,
    })
  }

  return (
    <Page
      variant="form"
      button="Сохранить"
      loading={[transferPolicyLoading]}
      value={formValue as any}
      onSubmit={handleSubmit}
      fields={[
        { name: 'id', type: 'string', label: 'ID', disabled: true },
        { name: 'createdAt', type: 'string', label: 'Создано', disabled: true },
        { name: 'updatedAt', type: 'string', label: 'Обновлено', disabled: true },
        {
          name: 'mode',
          type: 'select',
          label: 'Режим',
          options: MODE_OPTIONS,
        },
        {
          name: 'allowedCountries',
          type: 'string',
          label: 'Разрешённые страны',
          placeholder: 'LV, EE, LT',
          hide: (v) => !SHOW_COUNTRIES_MODES.includes(v?.mode),
        },
      ]}
    />
  )
}

export default TransferPolicyEdit
